import React from 'react';
import { createPortal } from 'react-dom';
import HEADER_CONSTANT from '../../HeaderComponent/AU/HeaderConstants/HeaderConstant';
import ImageComponent from 'atoms/Image';
import PopupCloseBtn from 'styles/staticAssets/images/PopupCloseBtn.svg';
import { ReactSVG } from 'react-svg';
import { ButtonComp } from 'atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { CartIconComp } from 'organisms/HeaderComponent/AU/Presentation/SharedTemplates/CartIcon';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { LanguageSelectorComp } from 'organisms/LanguageSelector/LanguageSelectorComp';
import { HeaderSigninComp } from 'organisms/HeaderComponent/AU/Presentation/SharedTemplates/HeaderSigninComp';
import { MenuLinksComp } from 'organisms/HeaderComponent/AU/Presentation/SharedTemplates/MenuLinksComp';
import { HamburgerSupportSection } from 'organisms/HamburgerMenu/Presentation/AU/HamburgerSupportSection';
import { useScrollLock } from 'common/custom-hooks/useScrollLock';
import { useSelector } from 'react-redux';

export const HamburgerMenuComp = props => {
  const { navRight, navLeft, navMobileMenu, onNavigateHandler, showHamburger, closeHamburger, languageObj } = props;
  const { supportCategory = {} } = navMobileMenu;
  const { LETS_GET_COOK } = HEADER_CONSTANT;
  const supportCategoryItemsLength = supportCategory?.subCategories?.length;
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { basic } = tenantReducer;

  useScrollLock();

  return createPortal(
    <div className='root-header-au'>
      <div id='hamburger-menu-comp' className={`hamburger-container${showHamburger ? ' side-nav-open' : ''}`}>
        <div className='hamburger-header-container'>
          <ButtonComp className='hamburger-close-button' data-testid='hamburger-close' onClickHandler={closeHamburger}>
            <ImageComponent srcFile={PopupCloseBtn} alt={'close'} />
          </ButtonComp>
          {basic?.allowedLanguages?.length <= 1 && (
            <span data-testid='header-stripes-icon' className='header-stripes-icon'>
              <ReactSVG src={IMAGE_PATH.Strips} />
            </span>
          )}
          {basic?.allowedLanguages?.length <= 1 && <CartIconComp gotoCart={onNavigateHandler} navRight={navRight} />}
          {<LanguageSelectorComp languageObj={languageObj} closeHamburger={closeHamburger} hamburgerMenu={true} />}
        </div>
        {basic?.allowedLanguages?.length > 1 && (
          <div className='langmodal-stripe-icon'>
            <ReactSVG src={IMAGE_PATH.Strips} />
          </div>
        )}

        <div className='hamburger-body-container'>
          <div data-testid='language-head-container' className='language-head-container'>
            <div data-testid='hamburger-heading' className='hamburger-heading'>
              {translateWithI18Next(LETS_GET_COOK)}
            </div>
          </div>
          <HeaderSigninComp navRight={navRight} closeHamburger={closeHamburger} hamburgerComp />
          <MenuLinksComp headerLinks={navLeft} onNavigateHandler={onNavigateHandler} />

          {supportCategoryItemsLength && (
            <HamburgerSupportSection className='footer-links' onClickHandler={onNavigateHandler} {...supportCategory} />
          )}
        </div>
      </div>
    </div>,
    document.getElementById('modal-popups'),
  );
};
